import { render, staticRenderFns } from "./FirmCard.vue?vue&type=template&id=e6c453aa&scoped=true&"
import script from "./FirmCard.vue?vue&type=script&lang=js&"
export * from "./FirmCard.vue?vue&type=script&lang=js&"
import style0 from "./FirmCard.vue?vue&type=style&index=0&id=e6c453aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c453aa",
  null
  
)

export default component.exports